import React from "react";
import {cardStyle} from "./style";

export const ItemPriceTitle = ({name, value, styles}) =>{
    const classes = cardStyle()
    return(
        <div className={classes.items} style={{...styles}}>
            <p>{name}</p>
            <span>{value}</span>
        </div>
    )
}